import React from "react"
import classnames from "classnames"

import styles from "./styles.css"

const DataTrafficSkeleton = () => {
  const classesContainer = classnames(styles.textInformation, styles.skeleton)

  return (
    <div className={styles.containerDetails}>
      <div className={classesContainer}></div>
      <div className={classesContainer}></div>
      <div className={classesContainer}></div>
      <div className={classesContainer}></div>
      <div className={classesContainer}></div>
    </div>
  )
}

export default DataTrafficSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/DataTrafficSkeleton/DetailsSkeleton.js